<template>
    <div class="position-relative d-inline-block">
            <span class="tooltip-number badge bg-primary">{{ numero }}</span>
            <span class="h4 ml-3 font-weight-bold">{{ descripcion }}</span>
        <slot class="test"></slot>
    </div>
</template>

<script>
export default {
    name: "PasoAPaso",
    props: {
        numero: {
            type: [Number, String],
            required: true
        },
        descripcion: {
            type: String,
            required: false
        }
    }
}
</script>

<style scoped>
.tooltip-number {
    top: -8px;
    left: -8px;
    font-size: 0.75rem;
    padding: 10px 16px;
    border-radius: 50%;
}
</style>